import { Col, Form, Row } from "antd";
import ControlledInput from "../../components/Backoffice/ControlledInput";

function AddOperator({ control, errors, watch, isEdit }) {
  return (
    <Form>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            required
            control={control}
            name="firstName"
            label="First Name"
            errors={errors}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            control={control}
            name="lastName"
            label="Last Name"
            errors={errors}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            required
            control={control}
            name="email"
            label="Email"
            errors={errors}
            disabled={isEdit}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            required
            control={control}
            name="phone"
            label="Phone"
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        {!isEdit && (
          <Col span={24}>
            <ControlledInput
              required
              control={control}
              name="password"
              label="Password"
              errors={errors}
            />
          </Col>
        )}
      </Row>
    </Form>
  );
}

export default AddOperator;
